module.exports = __webpack_public_path__ + "static/media/samir.56160b36.jpg";